import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducers';
import thunk from 'redux-thunk';

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
